module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.a35546ee.eot";